export const validateInvoiceCarrier = (carrier: string): boolean => {
  if (!carrier) return true;
  const carrierRegex = /^\/[0-9A-Z.+-]{7}$/;
  return carrierRegex.test(carrier);
};
